import { Pipe, type PipeTransform } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

import { processRichText } from './rich-text';

/**
 * Transforms a string through the rich-text pipeline (value interpolation,
 * LaTeX rendering, line break conversion) and returns sanitized HTML.
 *
 * Usage in templates:
 *   <span [innerHTML]="text | richText"></span>
 *   <span [innerHTML]="text | richText:resolveValue"></span>
 *   <span [innerHTML]="text | richText:resolveValue:2"></span>
 */
@Pipe({ name: 'richText', standalone: true, pure: true })
export class RichTextPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(
    value: string | number | null | undefined,
    resolveValue?: (path: string) => number | string | undefined,
    precision?: number,
  ): SafeHtml {
    if (value === null || value === undefined) {
      return '';
    }
    const text = String(value);
    const html = processRichText(text, resolveValue, precision);
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
